import { addAirDatapicker } from './dates.js';

// Fields that should NOT have <label> wrappers
const NO_LABEL_FIELDS = [
	'DOT',
	'Company Name',
	'Business Type',
	'Business Started Date',
	'Garage Address',
	'Effective Date'
];

// Fields that should have custom labels
// Key = data-editable_container_for value, Value = label text
const CUSTOM_LABELS = {
	line_2: 'Address Line 2',
	city: 'City',
	state_code: 'State:',
	zip: 'Zip:'
};

let STATES = [];

export function draw_address(lead_data) {
	if (!lead_data) {
		console.error('Error: lead_data is null or undefined');
		return;
	}

	// Make STATES accessible in the edit handler
	STATES = lead_data.states || [];

	let address = lead_data.address || {};
	let info = lead_data.info || {};

	if (!lead_data.address) {
		console.warn('No address data found in lead_data. Using empty fields.');
	}

	let line_1 = address.line_1 && address.line_1.length ? address.line_1 : '';
	let line_2 = address.line_2 && address.line_2.length ? address.line_2 : '';
	let city   = address.city && address.city.length ? address.city + ',' : '';
	let state_code = address.state_code && address.state_code.length ? address.state_code + ',' : '';
	let zip    = address.zip && address.zip.length ? address.zip : '';
	let dot    = address.dot && address.dot.length ? address.dot : '';
	let years_in_business = address.years_in_business && address.years_in_business.length
		? address.years_in_business
		: '';
	let company_name = address.company_name && address.company_name.length ? address.company_name : '';

	let last_policy_effective_date = address.effective_date_formatted && address.effective_date_formatted.length
		? address.effective_date_formatted
		: '';
	let saved_effective_date = info.effective_date_formatted && info.effective_date_formatted.length
		? info.effective_date_formatted
		: last_policy_effective_date;

	let business_started_date = address.business_started_date_formatted && address.business_started_date_formatted.length
		? address.business_started_date_formatted
		: '';

	let business_type_id = address.business_type_id && address.business_type_id > 0
		? address.business_type_id
		: 0;

	// Set the business_types_list selection
	$('#business_types_list').val(business_type_id);
	if (!$('#business_types_list').find('option:selected').length) {
		business_type_id = $('#business_types_list').children().first().val();
		$('#business_types_list').val(business_type_id);
	}
	let business_type_text = $('#business_types_list')
		.find(`[value="${$('#business_types_list').val()}"]`)
		.text();

	if (lead_data.loading) {
		business_type_text = '';
	}

	// Clear existing HTML
	$('#address-container .garage-address').html('');

	let line2Row = line_2
		? `<tr><td colspan="3" class="line_2" data-editable_container_for="line_2">${line_2}</td></tr>`
		: `<tr style="display:none;" class="line_2"><td colspan="3" data-editable_container_for="line_2"></td></tr>`;

	let city2 = city
		? `<tr><td colspan="3" class="city" data-editable_container_for="city">${city}</td></tr>`
		: `<tr style="display:none;"><td colspan="3" class="city" data-editable_container_for="city"></td></tr>`;

	// Build the display rows
	$('#address-container .garage-address').append(`
    <tr class="flex_col">
      <td class="title">DOT</td>
      <td colspan="3" class="dot" data-editable_container_for="dot">${dot}</td>
    </tr>
    <tr class="flex_col">
      <td class="title">Company Name</td>
      <td colspan="3" class="company_name" data-editable_container_for="company_name">${company_name}</td>
    </tr>
    <tr class="flex_col business_type_wrap">
      <td class="title">Business Type</td>
      <td colspan="3" class="business_type" data-editable_container_for="business_type_id" data-selected-value="${business_type_id}">
        ${business_type_text}
      </td>
    </tr>
    <tr class="flex_col business_started_date_wrap">
      <td class="title">Business Started Date</td>
      <td colspan="3" class="business_started_date date-field" data-editable_container_for="business_started_date">${business_started_date}</td>
    </tr>
    <tr class="flex_col years_in_business_wrap">
      <td class="title">Years in Business</td>
      <td colspan="3" class="years_in_business" data-editable_container_for="years_in_business">${years_in_business}</td>
    </tr>
    <tr class="flex_col tr_address_wrap">
      <td class="title">Garage Address</td>
      <td colspan="3" class="line_1" data-editable_container_for="line_1">${line_1}</td>
    </tr>
    ${line2Row}
    ${city2}
    <tr class="garage-address-bottom">
      <td class="state_code" data-editable_container_for="state_code">${state_code}</td>
      <td class="zip" data-editable_container_for="zip">${zip}</td>
    </tr>
    <tr class="flex_col effective_date_wrap">
      <td class="title">Effective Date</td>
      <td colspan="3" class="effective_date date-field" data-editable_container_for="effective_date">${saved_effective_date}</td>
    </tr>
  `);
}

$(document).ready(function () {

	$('#address-container').on('click', '.edit_address', function (e) {
		e.preventDefault();

		$('.garage-address tr').show();
		$('#address-container .garage-address').addClass('edditable');

		// Loop through each <td> with a data-editable_container_for
		$('#address-container .garage-address [data-editable_container_for]').each(function () {
			let text = $(this).text().trim();
			let container = $(this);

			// We'll figure out the final label text via the row's .title or fallback to data key
			let labelText = container.closest('tr').find('.title').text().trim();
			if (!labelText) {
				labelText = container.data('editable_container_for');
			}

			// Check if there's a custom label for this data-editable_container_for
			let containerKey = container.data('editable_container_for');
			if (CUSTOM_LABELS[containerKey]) {
				labelText = CUSTOM_LABELS[containerKey];
			}

			// Default is an <input type="text">
			let input = $('<input>', {
				type: 'text',
				value: text.replace(/,$/, ''),
				class: 'editable-input',
				placeholder: labelText,
				autocomplete: 'new-password'
			});

			// If it's the business type field => use #business_types_list options
			if (container.hasClass('business_type')) {
				input = $('<select>', { class: 'editable-input' })
					.append($('#business_types_list').children().clone());
				input.val(container.attr('data-selected-value'));
			}

			// If it's state_code => build a <select> from STATES array
			if (container.hasClass('state_code')) {
				input = $('<select>', { class: 'editable-input' });
				STATES.forEach(state => {
					// Expecting lead_data.states is something like [{ code: 'AL', name: 'Alabama' }, ...]
					input.append($('<option>', {
						value: state.code,
						text: state.name
					}));
				});
				// Original cell might have had "TX," so remove the comma
				let existingState = text.replace(',', '').trim();
				input.val(existingState);
			}

			// If it’s a date field
			if (container.hasClass('date-field')) {
				input.addClass('datepicker-input');
				input.attr('placeholder', 'MM/DD/YYYY');
			}

			// Decide if we skip the label or not
			if (!NO_LABEL_FIELDS.includes(labelText)) {
				let label = $('<label>', { class: 'edit-label' })
					.text(labelText + ' ')
					.append(input);
				container.empty().append(label);
			} else {
				// Skip label for fields in NO_LABEL_FIELDS
				container.empty().append(input);
			}
		});

		// Initialize date pickers
		addAirDatapicker($('#address-container .datepicker-input'));

		$(this).hide();
		$('#address-container .edit_btn_wrap').append(`
      <button data-id="7" class="abibus btn-success save_btn">
          <span class="abib">Save Changes</span>
      </button>
      <button data-id="7" class="abibus btn-cancel cancel_btn">
          <span class="abib">Cancel</span>
      </button>
    `);

		// Focus on the first editable input
		$('#address-container .garage-address input:first').focus();
	});

	$('#address-container').on('click', '.save_btn', function() {
		let data = {};

		$('#address-container .garage-address [data-editable_container_for]').each(function () {
			let editable_container_for = $(this).data('editable_container_for');
			let input = $(this).find('input, select');
			if (input.length && editable_container_for) {
				let typedValue = input.val().trim();

				// If business_type_id => store numeric value, display selected text
				if (editable_container_for === 'business_type_id') {
					$(this).attr('data-selected-value', typedValue);
					let selectedText = input.find('option:selected').text();
					$(this).text(selectedText);
					data[editable_container_for] = typedValue;
				}
				// If state_code => store typedValue, show typedValue + comma
				else if ($(this).hasClass('state_code')) {
					$(this).text(typedValue ? typedValue + ',' : '');
					data[editable_container_for] = typedValue;
				}
				// Else normal text
				else {
					$(this).text(typedValue);
					data[editable_container_for] = typedValue;
				}
			}
		});

		data.lead_id = $('.lead_update_popup').attr('data-current-lead-id');

		$.ajax({
			url: "/leads/update-address",
			type: "POST",
			dataType: "json",
			data: data,
			cache: false,
			success: function(result) {
				if (result.code === 'SUCCESS') {
					// Show a small confirmation
					$('<div class="confirmation-message">Address saved successfully!</div>')
						.css({
							'position': 'absolute',
							'color': 'green',
							'border': '1px solid green',
							'padding': '0px 10px',
							'margin-top': '-20px',
							'background-color': '#e6ffe6',
							'border-radius': '4px',
						})
						.prependTo('.garage-address')
						.fadeOut(1000);

					$('#address-container .save_btn, #address-container .cancel_btn').remove();
					$('#address-container .edit_address').show();
					$('#address-container .garage-address').removeClass('edditable');

					getLeadData(data.lead_id);
				} else {
					alert('Failed to save the address.');
				}
			},
			error: function() {
				alert('Error while saving the address.');
			}
		});
	});

	$('#address-container').on('click', '.cancel_btn', function(e) {
		e.preventDefault();
		e.stopPropagation();

		// Revert any unsaved changes
		$('#address-container .garage-address [data-editable_container_for]').each(function() {
			let input = $(this).find('input, select');
			if (input.length) {
				let originalText = input.attr('value') || '';
				if (input.is('select')) {
					let selectedText = input.find('option:selected').text();
					$(this).text(selectedText);
				} else {
					$(this).text(originalText);
				}
			}
		});

		$('#address-container .save_btn, #address-container .cancel_btn').remove();
		$('#address-container .edit_address').show();
		$('#address-container .garage-address').removeClass('edditable');
	});
});
